module.exports = __webpack_public_path__ + "static/media/foto2.e315ec86.png";